import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ResponseResult } from '@softline/core';
import { LagerplatzInhalt } from '@softapps/lager/core';
import {
  SOFTLINE_API_LAGER_PALETTENKORREKTUR,
  SOFTLINE_API_LAGER_SCAN_PALLET,
} from '../palettenkorrektur.api';

@Injectable()
export class PalletCorrectionRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async find(code: string): Promise<LagerplatzInhalt> {
    return (
      await this.#dataAccess.get<ResponseResult<LagerplatzInhalt>>({
        path: SOFTLINE_API_LAGER_SCAN_PALLET,
        pathParams: { code },
      })
    )?.result;
  }

  async save(palletId: number, corrections: any[]): Promise<unknown> {
    return await this.#dataAccess.create(
      {
        path: SOFTLINE_API_LAGER_PALETTENKORREKTUR,
      },
      {
        palettenId: palletId,
        korrekturen: corrections,
      }
    );
  }
}
